export default __webpack_public_path__ + "101d6af45a7ca33ad05a65f3f67b4b32.svg";